module.exports = __webpack_public_path__ + "static/media/3.3821aee0.webp";